(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tachon-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tachon-slideshow')) {
    class TachonSlideshow extends HTMLElement {
      constructor() {
        super();
        this.tick = this.tick.bind(this);
        this.prev = this.prev.bind(this);
        this.next = this.next.bind(this);
        this.togglePause = this.togglePause.bind(this);
        this.onStageClick = this.onStageClick.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onVisibility = this.onVisibility.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.ts-slide'));
        this.fills = Array.from(this.querySelectorAll('.ts-seg-fill'));
        this.path = this.querySelector('.ts-scribble-path');
        this.stage = this.querySelector('.ts-stage');
        this.pauseBtn = this.querySelector('[data-ts-pause]');
        this.total = this.slides.length;
        if (!this.total) return;

        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.duration = Math.max(2, parseFloat(this.dataset.duration) || 6) * 1000;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduced && this.total > 1;
        this.mode = this.reduced ? 'fade' : this.dataset.transition;
        if (this.reduced) this.dataset.transition = 'fade';

        this.index = 0;
        this.elapsed = 0;
        this.busy = false;
        this.userPaused = !this.autoplay;
        this.hoverPaused = false;
        this.editorPaused = false;
        this.inView = true;
        this.pageVisible = !document.hidden;
        this.swiped = false;

        const prevBtn = this.querySelector('[data-ts-prev]');
        const nextBtn = this.querySelector('[data-ts-next]');
        if (prevBtn) prevBtn.addEventListener('click', this.prev);
        if (nextBtn) nextBtn.addEventListener('click', this.next);
        if (this.pauseBtn) this.pauseBtn.addEventListener('click', this.togglePause);

        this.stage.addEventListener('click', this.onStageClick);
        this.stage.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.stage.addEventListener('touchend', this.onTouchEnd, { passive: true });
        this.addEventListener('keydown', this.onKey);
        this.addEventListener('submit', this.onSubmit);
        this.addEventListener('mouseenter', () => { this.hoverPaused = true; });
        this.addEventListener('mouseleave', () => { this.hoverPaused = false; });
        this.addEventListener('focusin', () => { this.hoverPaused = true; });
        this.addEventListener('focusout', () => { this.hoverPaused = false; });

        document.addEventListener('visibilitychange', this.onVisibility);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
          }, { threshold: 0.3 });
          this.observer.observe(this);
        }

        this.syncPauseUI();
        this.paint();
        this.last = performance.now();
        this.raf = requestAnimationFrame(this.tick);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.raf);
        clearTimeout(this.timer);
        if (this.observer) this.observer.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      running() {
        return this.autoplay && !this.userPaused && !this.hoverPaused && !this.editorPaused
          && this.inView && this.pageVisible && !this.busy;
      }

      tick(now) {
        const dt = now - this.last;
        this.last = now;
        if (this.running()) {
          this.elapsed += dt;
          if (this.elapsed >= this.duration) this.go(this.index + 1);
        }
        this.paint();
        this.raf = requestAnimationFrame(this.tick);
      }

      paint() {
        const ratio = this.autoplay ? Math.min(1, this.elapsed / this.duration) : 1;
        this.fills.forEach((fill, k) => {
          const w = k < this.index ? 1 : (k > this.index ? 0 : ratio);
          fill.style.width = (w * 100).toFixed(2) + '%';
        });
      }

      go(target, instant) {
        if (this.busy || this.total < 2) return;
        const n = ((target % this.total) + this.total) % this.total;
        if (n === this.index) return;

        if (instant || this.mode !== 'tachon' || !this.path) {
          this.activate(n, !instant);
          return;
        }

        this.busy = true;
        const path = this.path;
        const length = path.getTotalLength();
        path.style.transition = 'none';
        path.style.stroke = this.slides[n].dataset.bg;
        path.style.strokeDasharray = length;
        path.style.strokeDashoffset = length;
        path.style.visibility = 'visible';
        path.getBoundingClientRect();
        path.style.transition = 'stroke-dashoffset 800ms cubic-bezier(0.65, 0, 0.35, 1)';
        path.style.strokeDashoffset = '0';

        this.timer = setTimeout(() => {
          this.activate(n, true);
          path.style.visibility = 'hidden';
          this.busy = false;
        }, 830);
      }

      activate(n, animate) {
        this.slides.forEach((slide, k) => {
          const on = k === n;
          slide.classList.toggle('is-active', on);
          slide.classList.remove('is-entering');
          if (on) {
            slide.removeAttribute('aria-hidden');
            slide.inert = false;
          } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.inert = true;
          }
        });
        const current = this.slides[n];
        if (animate) {
          void current.offsetWidth;
          current.classList.add('is-entering');
        }
        this.style.setProperty('--ts-fg', current.dataset.fg);
        this.index = n;
        this.elapsed = 0;
        this.paint();
      }

      prev() { this.go(this.index - 1); }
      next() { this.go(this.index + 1); }

      togglePause() {
        if (this.userPaused || !this.autoplay) {
          this.userPaused = false;
          this.autoplay = this.total > 1;
        } else {
          this.userPaused = true;
        }
        this.last = performance.now();
        this.syncPauseUI();
      }

      syncPauseUI() {
        const paused = this.userPaused || !this.autoplay;
        this.classList.toggle('is-paused', paused);
        if (this.pauseBtn) this.pauseBtn.setAttribute('aria-label', paused ? 'Reproducir' : 'Pausar');
        this.stage.setAttribute('aria-live', paused ? 'polite' : 'off');
      }

      onStageClick(event) {
        if (this.swiped) { this.swiped = false; return; }
        if (event.target.closest('a, button, input, select, textarea, form, label')) return;
        const rect = this.getBoundingClientRect();
        if (event.clientX - rect.left < rect.width * 0.3) this.prev();
        else this.next();
      }

      onTouchStart(event) {
        const t = event.changedTouches[0];
        this.touchX = t.clientX;
        this.touchY = t.clientY;
      }

      onTouchEnd(event) {
        const t = event.changedTouches[0];
        const dx = t.clientX - this.touchX;
        const dy = t.clientY - this.touchY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          this.swiped = true;
          if (dx < 0) this.next(); else this.prev();
          setTimeout(() => { this.swiped = false; }, 400);
        }
      }

      onKey(event) {
        if (event.target.closest('input, textarea, select')) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); this.next(); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.prev(); }
      }

      onVisibility() {
        this.pageVisible = !document.hidden;
        this.last = performance.now();
      }

      onBlockSelect(event) {
        if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
        const n = this.slides.findIndex((s) => s.dataset.blockId === event.detail.blockId);
        if (n < 0) return;
        this.editorPaused = true;
        clearTimeout(this.timer);
        this.busy = false;
        if (this.path) this.path.style.visibility = 'hidden';
        if (n !== this.index) this.activate(n, false);
      }

      onBlockDeselect(event) {
        if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.editorPaused = false;
      }

      onSubmit(event) {
        const form = event.target.closest('[data-ts-atc]');
        if (!form || this.dataset.atc !== 'stay' || !window.fetch) return;
        event.preventDefault();

        const button = form.querySelector('button[type="submit"]');
        const label = button.textContent;
        const id = Number(form.querySelector('[name="id"]').value);
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        button.disabled = true;

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then((response) => (response.ok ? response.json() : Promise.reject(response)))
          .then((data) => {
            button.textContent = 'Agregado';
            this.userPaused = true;
            this.syncPauseUI();
            this.showCartLink(form, root);
            this.onAdded(data);
            setTimeout(() => { button.textContent = label; button.disabled = false; }, 2500);
          })
          .catch(() => {
            button.textContent = 'No se pudo agregar';
            setTimeout(() => { button.textContent = label; button.disabled = false; }, 2500);
          });
      }

      showCartLink(form, root) {
        if (form.parentElement.querySelector('.ts-cartlink')) return;
        const link = document.createElement('a');
        link.href = root + 'cart';
        link.className = 'ts-cartlink';
        link.textContent = 'Ver carrito';
        form.after(link);
      }

      onAdded(data) {
        document.dispatchEvent(new CustomEvent('tachon:cart:added', { detail: data, bubbles: true }));
        // PARA EL DISEÑADOR: conecta aquí la función de Minimog que abre el carrito lateral
        // y actualiza el contador del encabezado.
      }
    }

    customElements.define('tachon-slideshow', TachonSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
